module.exports = __webpack_public_path__ + "static/media/hull_color_style_0001.904592db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hullColors/hull_color_style_0001.jpg
// module id = 619
// module chunks = 0